export const config = {
  env: {
    type: import.meta.env.VITE_ENV_TYPE,
    url: import.meta.env.VITE_ENV_URL,
    buildInfo: import.meta.env.VITE_BUILD_INFO,
    layerSeven: import.meta.env.VITE_ENV_LAYERSEVEN,
    helpAndSupport: import.meta.env.VITE_HELP_AND_SUPPORT,
    branchIoUrl: import.meta.env.VITE_ENV_BRANCH_IO,
    branchIoAttdelLink: import.meta.env.VITE_LNK_ATTDEL_BRANCH_IO,
    branchIoLiiaspLink: import.meta.env.VITE_LNK_LIIASP_BRANCH_IO,
  },
  auth0: {
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
    env: import.meta.env.VITE_AUTH0_ENV,
    redirectUrl: import.meta.env.VITE_AUTH0_REDIRECT_URL,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  },
  api: {
    edd: import.meta.env.VITE_API_EDD,
    postcodeLookup: import.meta.env.VITE_API_POSTCODE,
    locations: import.meta.env.VITE_API_LOCATIONS,
    branchIo: import.meta.env.VITE_API_BRANCH_IO,
    shipmentsGateway: import.meta.env.VITE_API_SHIPMENT_GATEWAY, //For dynamic comms
  },
  branchConfigs: {
    baseUrl: import.meta.env.VITE_ENV_BRANCH_IO,
    attemptedDeliveryQuickLink: import.meta.env.VITE_LNK_ATTDEL_BRANCH_IO,
    liiaspQuickLink: import.meta.env.VITE_LNK_LIIASP_BRANCH_IO,
  },
};

// Test env config invalidation
